export function getUploadDestinationDriveID(fileUploadState) {
    return fileUploadState.parent
        ? fileUploadState.parent.parentReference.driveId
        : undefined;
}
//# sourceMappingURL=getUploadDestinationDriveID.js.map